import { useState } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Lock, User } from "lucide-react";
import AuthService from "../service/AuthService";
import { useToastContext } from "../provider/ToastContext";
import { AxiosError } from "axios";
import { Link, useNavigate } from "react-router-dom";


const authService = new AuthService();
export function TrocarSenhaPage() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { msgAlerta, msgSucesso } = useToastContext();

  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!password) {
      msgAlerta("Senha inválida", "A senha não pode ser vazia.");
      return;
    }
    if (password !== confirmPassword) {
      msgAlerta("As senhas não coincidem", "Por favor, verifique e tente novamente.");
      return;
    }
    authService.trocarSenha(token, password).then(() => {
      msgSucesso("Senha alterada com sucesso", "Você já pode fazer login com sua nova senha.");
      navigate("/");
    }).catch((err: AxiosError) => {
      console.log(err)
      msgAlerta("Não foi possível alterar a senha", "Tente novamente mais tarde.");
    });
  };

  return (
    <div className="gradient-bg flex align-items-center justify-content-center p-4">
      <Card className="login-card shadow-4">
        <div className="text-center mb-4">
          <div className="login-icon">
            <img src="/logo.png" alt="Logo" width={80} />
          </div>
          <h2 className="mb-2">Alteração de senha</h2>
          <p className="text-muted">Preencha os campos abaixo para alterar a senha</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="password" className="block mb-2">
              Nova Senha
            </label>
            <span className="p-input-icon-left w-full">
              <Lock size={20} style={{ marginLeft: 8, marginRight: 8 }} />
              <InputText
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full"
                style={{ paddingLeft: 32 }}
                required
              />
            </span>
          </div>

          <div className="mb-3">
            <label htmlFor="confirmPassword" className="block mb-2">
              Confirmar nova Senha
            </label>
            <span className="p-input-icon-left w-full">
              <Lock size={20} style={{ marginLeft: 8, marginRight: 8 }} />
              <InputText
                id="confirmPassword"
                type="password"
                placeholder="••••••••"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full"
                style={{ paddingLeft: 32 }}
                required
              />
            </span>
          </div>

          <Button
            type="submit"
            label="Alterar Senha"
            className="w-full mb-3"
          />
        </form>
      </Card>
    </div>
  );
}
